<div class="breadcrumbs">
  <div class="content-wrapper">
    <div class="breadcrumbs-container"> <a [routerLink]="'/'" class="breadcrumbs-link-home">Strona główna</a> &raquo; <span>Informacje prawne</span> </div>
  </div>
</div>

<main class="page">
  <div class="content-wrapper">
    <section class="tw-medium-padding">
      <div class="section-header">
        <h3 class="section-title">Określenie właściciela</h3>
      </div>

      <p>Właścicielem tej domeny internetowej oraz podmiotem wyłącznie odpowiedzialnym jest:</p>

      <p>
        <b>MS WORKS Michał Szewczyk</b><br />
        ul. Chabrowa 73A<br />
        05-084 Wilkowa Wieś, Polska<br />
      </p>

      <p>
        tel.: +&#52;&#56; &#54;&#48;&#50; &#55;&#53;&#57; &#52;&#53;&#51;<br />
        e-mail: &#98;&#105;&#117;&#114;&#111;&#64;&#109;&#101;&#98;&#108;&#101;&#46;&#112;&#114;&#111;
      </p>

      <p> Numer identyfikacji podatkowej: PL5221910022 </p>
    </section>

    <section class="tw-medium-padding tw-no-top-padding">
      <p>Sądem wlaściwym dla siedziby firmy jest:</p>
      <p>
        <b>Sąd Rejonowy w Grodzisku Mazowieckim</b><br />
        ul. Bartniaka 21/23<br />
        05-825 Grodzisk Mazowiecki, Polska<br />
        NIP: 529-12-38-558
      </p>
    </section>
  </div>
</main>
